<!-- Booking Caldendar -->
<div class="card border-0 shadow-sm" [ngStyle]="{'height': getCalendarCardHeightCLS()}" style="height: 725px">
  <!-- Title & Price -->
  <ng-container *ngIf="bookingType == BookingType.Safari || bookingType == BookingType.Climb">
    <header id="SVGwave1BottomShapeID2"
            class="card-header border-0 position-relative bg-{{headerColor}} text-white p-5"
            style="padding-bottom:6.5rem!important"
            [ngClass]="{'shadowed' : hasTextShadow}">
      <h3 class="h4 mb-1">{{titleString}}</h3>
      <span class="d-block pb-5 pb-sm-2">
        <span class="align-top">$</span>
        <span class="display-4 font-weight-semi-bold">{{calendarModes[modeIndex].priceInDollars}}</span>
        <!-- Line Break on XS & S devices -->
        <div class="clearfix d-sm-none"> </div>
        <span>/ per {{priceSubject}}</span>
      </span>
      <ng-container *ngIf="headerColor == 'alt'">
        <div class="d-flex flex-wrap">
          <a role="button" *ngIf="!isMobile()" (click)="openBookingCalendar()"
             class="btn btn-pill btn-primary btn-block my-2 transition-3d-hover" style="z-index:5; cursor: pointer">FIND A DATE NOW<app-fa-icon iconName="calendar" classes="ml-2" bottomMargin="-.23rem"></app-fa-icon></a>
        </div>
      </ng-container>
      <div class="position-absolute right-0 bottom-0 left-0 w-100">
        <figure class="ie-wave-1-bottom">
          <img src="../assets/svg/components/wave-1-bottom.svg"
               alt="SVG Wave"
               class="w-100"
               data-parent="#SVGwave1BottomShapeID2">
        </figure>
      </div>
    </header>
  </ng-container>
  <!-- End Title & Price -->

  <!-- Button Group -->
  <ng-container *ngIf="calendarModes.length > 1">
    <div class="ml-5 mb-1" [ngClass]="(bookingType == BookingType.All)?'space-top-1':''">
            <span class="text-dark font-weight-bold"
                  [ngClass]="(bookingType == BookingType.All)?'h5':''">{{calendarModePrompt}}</span><br
      *ngIf="isMobile()">
      <span class="btn-group-toggle">
              <ng-container *ngFor="let mode of calendarModes; let i = index">
                <a id="btn-{{i}}"
                   class="js-animation-link mx-2 mt-1 badge badge-dark badge-pill badge-bigger btn btn-outline-secondary btn-custom-toggle-primary"
                   href="javascript:;"
                   (click)="setMode(i)"
                   data-target=""
                   data-link-group="selectorGroup"
                   data-animation-in="">{{mode.selectorText}}</a>
              </ng-container>
            </span>
      <ng-container *ngIf="bookingType == BookingType.All">
        <span class=" my-float text-dark mt-2 mr-6">Parties 3+ in size enjoy big Safari discounts!</span><br>
      </ng-container>
    </div>
  </ng-container>
  <!-- End Button Group -->

  <!-- Calendar -->
  <div class="card-body pt-0 pb-3 px-md-5" [ngClass]="(bookingType == BookingType.All)?'px-0':'px-5'">
    <!-- FareHarbor calendar/s -->
    <div class="phoneRowMargin row" *ngIf="bookingType == BookingType.All">
      <div class="col-lg-4  col-md-12 col-sm-12">
        <app-fa-icon iconName="phone" color="dark" classes="phone-link font-weight-bold" width="1.25" height="1.75"></app-fa-icon>
        <a class="phone-link font-weight-bold badWidthFixPhone" href="tel:866-816-5672" style="font-size: 1.25rem;">866-816-KOPA</a>
      </div>
      <ng-container *ngIf="bookingType == BookingType.All">
        <div class=" col-lg-8 col-md-12 col-sm-12 viewBadgeRow">
          <a class="badge badge-secondary badge-pill badge-bigger btn badgeDesktop responsiveTopMargin"
             routerLink="../../kilimanjaro" fragment="explore-the-routes">View Detailed Kilimanjaro Itineraries</a><br
          *ngIf="isMobile()"><br *ngIf="isMobile()">
          <a class="badge badge-success badge-pill badge-bigger btn mr-2 badgeDesktop responsiveTopMargin"
             routerLink="../../safari">View Detailed Safari Itineraries</a><br *ngIf="isMobile()"><br
          *ngIf="isMobile()">
          <a class="badge badge-primary badge-pill badge-bigger btn mr-2 badgeDesktop responsiveTopMargin"
             routerLink="../../helpful-information/about-us" fragment="whybook">Why Book With Us?</a>
        </div>
      </ng-container>
    </div>
    <ng-container *ngFor="let mode of calendarModes; let i = index">
      <div #calendarTag id="calendar{{i}}"></div>
    </ng-container>
    <div *ngIf="bookingType == BookingType.Climb" class="text-center position-absolute bottom-0 left-0 right-0">
      <span class="text-dark font-weight-bold">Questions about this trip?</span><br>
      <div class="my-2 ml-md-0">
        <app-kopa-button color="secondary" text="Send us a message" link="../../helpful-information"></app-kopa-button>
      </div>
    </div>
  </div>
  <!-- End Calendar -->
</div>
<a id="fareharborLink" class="d-none"
   href="https://fareharbor.com/embeds/book/kopatours/items/{{calendarModes[modeIndex].calendarId}}/?flow=237165&back={{refUrl}}"></a>
<!-- End Booking Caldendar -->
